import {Mapper} from '@s-ui/domain'

const DEFAULT_NEWS_LABEL = 'portada'
const EVENT_NAME_NEWS = 'editorial_news'

export default class AdvertisingNewsValueObjectMapper extends Mapper {
  constructor({config, valueObjectFactory}) {
    super({config, valueObjectFactory})
    this._config = config
    this._configPage = this._config.get('page')
    this._culture = this._config.get('DEFAULT_CULTURE')
    this._lang = this._config.get('URL_CULTURES_MAP')[this._culture]
    this._valueObjectFactory = valueObjectFactory
  }

  _getEventName = ({category, tag, searchTerm}) => {
    if (category) {
      const newsCategoryId = this._getNewsCategoryId({category})
      return newsCategoryId ? `editorial_${newsCategoryId}` : EVENT_NAME_NEWS
    }

    if (tag || searchTerm) {
      return 'editorial_search'
    }

    return EVENT_NAME_NEWS
  }

  _getNewsCategoryId = ({category}) =>
    this._config.get('editorial').newsCategories.find(({path}) => category === path).id

  _getLabels = ({category, tag, searchTerm, section}) => category || tag || searchTerm || section || DEFAULT_NEWS_LABEL

  map = ({category, tag, searchTerm, section}) => {
    const trackingConfig = this._config.get('tracking')
    const adsNamePage = trackingConfig.ADS_NAME_PAGE_NEWS

    return this._valueObjectFactory({
      ads_name_page: adsNamePage,
      event_name: this._getEventName({category, tag, searchTerm}),
      labels: this._getLabels({category, tag, searchTerm, section}),
      country_code: this._lang,
      site: this._config.get('TENANT')
    })
  }
}
